import { swpRebalance } from "../../engine/calculations";

const config = {
  key: "swp-rebalance",
  title: "SWP Rebalance",
  category: "Retirement & Income",
  description: "Withdraw from a two-asset (equity/debt) portfolio that periodically rebalances back to your target split.",
  fields: [
    { key: "corpus", label: "Corpus", type: "currency", default: 50_00_000, min: 1000, max: 50_00_00_000 },
    { key: "equityPct", label: "Equity allocation", type: "percent", default: 60, min: 0, max: 100 },
    { key: "equityRate", label: "Equity return", type: "percent", default: 12, min: 0, max: 30, assumptionKey: "equityReturn" },
    { key: "debtRate", label: "Debt return", type: "percent", default: 7, min: 0, max: 20, assumptionKey: "debtReturn" },
    { key: "withdrawal", label: "Monthly withdrawal", type: "currency", default: 30_000, min: 0, max: 50_00_000 },
    { key: "years", label: "Period (years)", type: "number", default: 15, min: 1, max: 40 },
    { key: "rebalanceMonths", label: "Rebalance every (months)", type: "number", default: 12, min: 1, max: 60, help: "How often the portfolio is brought back to your target equity/debt split." },
  ],
  chart: {
    type: "line",
    xKey: "year",
    series: [
      { key: "equity", label: "Equity", colorVar: "--gold" },
      { key: "debt", label: "Debt", colorVar: "--muted" },
    ],
  },
  compute(values) {
    const corpus = Number(values.corpus) || 0;
    const equityPct = (Number(values.equityPct) || 0) / 100;
    const debtPct = 1 - equityPct;
    const equityRate = (Number(values.equityRate) || 0) / 100;
    const debtRate = (Number(values.debtRate) || 0) / 100;
    const withdrawal = Number(values.withdrawal) || 0;
    const years = Number(values.years) || 0;
    const rebalanceMonths = Math.round(Number(values.rebalanceMonths) || 12);

    const result = swpRebalance(corpus, equityPct, debtPct, equityRate, debtRate, withdrawal, years, rebalanceMonths);
    const series = result.schedule
      .filter((row) => row.month % 12 === 0)
      .map((row) => ({ year: row.month / 12, equity: row.equity, debt: row.debt }));

    return {
      headline: { label: "Final portfolio value", value: result.finalTotal },
      extraHeadlines: [
        { label: "Final equity", value: result.finalEquity },
        { label: "Final debt", value: result.finalDebt },
      ],
      breakdown: [
        { label: "Starting corpus", value: corpus },
        { label: "Total withdrawn", value: withdrawal * years * 12 },
      ],
      series,
    };
  },
};

export default config;
